import React from "react";
import { Card, Image } from "semantic-ui-react";
import { Product } from "api/types";
import { NavLink } from "react-router-dom";

interface IProp {
  product: Product;
}

const ProductListItem = ({ product }: IProp) => {
  const {
    id,
    styleNumber,
    name,
    isOnesize,
    regularPrice,
    plusPrice,
    onesizePrice,
    thumbnail,
    // updatedAt,
    // createdAt,
  } = product;

  const renderPrice = () => {
    if (isOnesize) {
      return (
        <div>
          <strong>OneSize: $</strong>
          {(onesizePrice / 100).toFixed(2)}
        </div>
      );
    }
    return (
      <>
        <div>
          <strong>Reg: $</strong>
          {(regularPrice / 100).toFixed(2)}
        </div>
        <div>
          <strong>Plus: $</strong>
          {(plusPrice / 100).toFixed(2)}
        </div>
      </>
    );
  };

  return (
    <Card style={{ width: "140px" }}>
      <Image size="small" centered src={thumbnail} />
      <Card.Content>
        <Card.Header as={NavLink} to={`/products/${id}`}>
          {styleNumber}
        </Card.Header>
        <Card.Meta
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </Card.Meta>
        <Card.Description>{renderPrice()}</Card.Description>
      </Card.Content>
    </Card>
  );
};

export default ProductListItem;
